import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import * as Constants from '../../../common/Global/constants';
import { getLocalStorageVariables, handleTokenExpiry, isEmptyArray } from "../../../common/Global/commonFunctions";

let userDetails = getLocalStorageVariables();

class PreviousMailDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mailList: [],
            showLoader: false,
            selectedMail: null,
        };
        userDetails = getLocalStorageVariables();
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.showPreviousMailDialog && this.props.showPreviousMailDialog) {
            this.fetchPreviousMails();
        }
    }

    fetchPreviousMails = () => {
        this.setState({ showLoader: true, mailList: [], selectedMail: null });

        fetch(Constants.EmployeeNotificationList, {
            method: "POST",
            mode: 'cors',
            body: new URLSearchParams({
                email: userDetails.email,
                accessToken: userDetails.accessToken,
                assignmentId: this.props.assignmentId,
                screen: this.props.screen,
            })
        })
        .then(response => response.json())
        .then(data => {
            if (handleTokenExpiry(data.responseCode)) return;
            if (data.responseCode === Constants.CODE_SUCCESS) {
                this.setState({ 
                    showLoader: false, 
                    mailList: data.data.mailHistory 
                });
            } else {
                this.setState({ showLoader: false });
            }
        })
        .catch(() => {
            this.setState({ showLoader: false });
        });
    }

    handleSelectMail = (mail) => {
        this.setState({ selectedMail: mail });
    }

    handleBackToList = () => {
        this.setState({ selectedMail: null });
    }

    handleClose = () => {
        this.setState({ selectedMail: null, mailList: [] });
        this.props.handlePreviousMailDialogClose();
    }

    formatDate = (dateStr) => {
        if (!dateStr) return '-';
        const d = new Date(dateStr);
        if (isNaN(d)) return dateStr;
        return d.toLocaleString('en-GB', {
            day: '2-digit', month: 'short', year: 'numeric',
            hour: '2-digit', minute: '2-digit', hour12: true
        });
    }

    renderListView() {
        return (
            <>
                <div className="modal-body p-0" style={{ minHeight: 300, maxHeight: 480, overflowY: 'auto' }}>
                    {this.state.showLoader && (
                        <div className="d-flex justify-content-center align-items-center" style={{ height: 200 }}>
                            <div className="spinner-border text-secondary" role="status">
                                <span className="sr-only">Loading...</span>
                            </div>
                        </div>
                    )}

                    {!this.state.showLoader && isEmptyArray(this.state.mailList) && (
                        <div className="d-flex justify-content-center align-items-center text-muted" style={{ height: 200, fontSize: 14 }}>
                            No previous mails found.
                        </div>
                    )}

                    {!this.state.showLoader && 
                    !isEmptyArray(this.state.mailList) && 
                    this.state.mailList.map((mail, index) => (
                        <div
                            key={mail.mailResponseId || index}
                            className="d-flex align-items-start px-3 py-3 border-bottom"
                            style={{ cursor: 'pointer' }}
                            onClick={() => this.handleSelectMail(mail)}
                            onMouseEnter={e => e.currentTarget.style.background = '#f5f5f5'}
                            onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                        >
                            <span className="material-icons mr-3 mt-1" style={{ fontSize: 20, flexShrink: 0, color: `rgba(${this.props.themeSettings.themeColor.r},${this.props.themeSettings.themeColor.g},${this.props.themeSettings.themeColor.b},${this.props.themeSettings.themeColor.a})` }}>
                                email
                            </span>
                            <div className="flex-grow-1" style={{ minWidth: 0 }}>
                                <div className="d-flex justify-content-between align-items-center mb-1">
                                    <span style={{ fontSize: 14, fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                        {mail.subject || '(No Subject)'}
                                    </span>
                                    <span className="text-muted ml-3" style={{ fontSize: 12, flexShrink: 0 }}>
                                        {this.formatDate(mail.createDate)}
                                    </span>
                                </div>
                                {mail.toList && (
                                    <div className="text-muted text-truncate" style={{ fontSize: 13 }}>
                                        <span style={{ marginRight: 4 }}>To:</span>
                                        {mail.toList}
                                    </div>
                                )}
                                {mail.ccList && (
                                    <div className="text-muted text-truncate" style={{ fontSize: 12 }}>
                                        <span style={{ marginRight: 4 }}>Cc:</span>
                                        {mail.ccList}
                                    </div>
                                )}
                                {mail.bccList && (
                                    <div className="text-muted text-truncate" style={{ fontSize: 12 }}>
                                        <span style={{ marginRight: 4 }}>Bcc:</span>
                                        {mail.bccList}
                                    </div>
                                )}
                                <div className="text-muted" style={{ fontSize: 12 }}>
                                    <span style={{ marginRight: 4 }}>Sent by:</span>
                                    {mail.createBy || '-'}
                                </div>
                            </div>
                            <span className="material-icons text-muted ml-2 mt-1" style={{ fontSize: 18, flexShrink: 0 }}>
                                chevron_right
                            </span>
                        </div>
                    ))}
                </div>

                <div className="modal-close-save m-t-15 mb-3 d-flex justify-content-end px-3">
                    <button onClick={this.handleClose} type="button" className="modal-close m-b-0">
                        Close
                    </button>
                </div>
            </>
        );
    }

    renderDetailView() {
        return (
            <>
                <div className="modal-body p-0 d-flex flex-column" style={{ maxHeight: 480, overflowY: 'auto' }}>
                    {/* Recipients info bar */}
                    <div className="border-bottom px-3 py-2" style={{ fontSize: 13, background: '#fafafa' }}>
                        {this.state.selectedMail.subject && (
                            <div className="d-flex align-items-start py-1 border-bottom">
                                <span className="text-muted" style={{ width: 70, flexShrink: 0 }}>Subject</span>
                                <span style={{ fontWeight: 600 }}>{this.state.selectedMail.subject}</span>
                            </div>
                        )}
                        <div className="d-flex align-items-start py-1 border-bottom">
                            <span className="text-muted" style={{ width: 70, flexShrink: 0 }}>Date</span>
                            <span>{this.formatDate(this.state.selectedMail.createDate)}</span>
                        </div>
                        <div className="d-flex align-items-start py-1 border-bottom">
                            <span className="text-muted" style={{ width: 70, flexShrink: 0 }}>Sent by</span>
                            <span>{this.state.selectedMail.createBy || '-'}</span>
                        </div>
                        {this.state.selectedMail.toList && (
                            <div className="d-flex align-items-start py-1 border-bottom">
                                <span className="text-muted" style={{ width: 70, flexShrink: 0 }}>To</span>
                                <span>{this.state.selectedMail.toList}</span>
                            </div>
                        )}
                        {this.state.selectedMail.ccList && (
                            <div className="d-flex align-items-start py-1 border-bottom">
                                <span className="text-muted" style={{ width: 70, flexShrink: 0 }}>Cc</span>
                                <span>{this.state.selectedMail.ccList}</span>
                            </div>
                        )}
                        {this.state.selectedMail.bccList && (
                            <div className="d-flex align-items-start py-1">
                                <span className="text-muted" style={{ width: 70, flexShrink: 0 }}>Bcc</span>
                                <span>{this.state.selectedMail.bccList}</span>
                            </div>
                        )}
                    </div>

                    {/* Mail body */}
                    <div className="px-3 py-3 flex-grow-1">
                        {this.state.selectedMail.mailHtml
                            ? <div dangerouslySetInnerHTML={{ __html: this.state.selectedMail.mailHtml }} />
                            : <span className="text-muted" style={{ fontSize: 13 }}>No content available.</span>
                        }
                    </div>
                </div>

                <div className="modal-close-save m-t-15 mb-3 d-flex justify-content-between align-items-center px-3">
                    <button
                        onClick={this.handleBackToList}
                        type="button"
                        className="modal-close m-b-0 d-flex align-items-center"
                    >
                        <span className="material-icons mr-1" style={{ fontSize: 16 }}>arrow_back</span>
                        Back
                    </button>
                    <button onClick={this.handleClose} type="button" className="modal-close m-b-0">
                        Close
                    </button>
                </div>
            </>
        );
    }

    render() {
        const { selectedMail } = this.state;

        return (
            <section>
                <Modal
                    className="task-select-dept-dialog custom-dialog"
                    size="lg"
                    show={this.props.showPreviousMailDialog}
                    backdrop="static"
                >
                    <Modal.Header>
                        <div className="d-flex align-items-center">
                            {selectedMail && (
                                <span
                                    className="material-icons mr-2"
                                    style={{ fontSize: 20, cursor: 'pointer' }}
                                    onClick={this.handleBackToList}
                                >
                                    arrow_back
                                </span>
                            )}
                            <h5 className="m-0">
                                {selectedMail ? 'Mail Details' : 'Previous Mails'}
                            </h5>
                        </div>
                        <button onClick={this.handleClose} type="button" data-dismiss="modal">
                            <span className="material-icons">close</span>
                        </button>
                    </Modal.Header>

                    <hr />

                    {selectedMail ? this.renderDetailView() : this.renderListView()}
                </Modal>
            </section>
        );
    }
}

export default PreviousMailDialog;
